import styled, { css, keyframes } from 'styled-components';
import { color } from '../../stylesheets';

export type SkeletonProps = {
  width?: string;
  height?: string;
};

const loading = keyframes`
  0% {
    background-color: #F8F5F2;
  }

  100% {
    background-color: #F8F5F2;
  }
`;

const Skeleton = styled.div<SkeletonProps>`
  position: relative;
  display: block;
  overflow: hidden;
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '100%'};
  animation: ${loading} 2s linear infinite alternate;
`;

export default Skeleton;
